'use strict';
angular.module('ueditorForWeixinModule', []).directive('ueditorForWeixin', [
    '$q',
    '$compile',
    '$sce',
    '$interval',
    'ueditorBtnService',
    'ueditorService',
    '$timeout',
    'ueditorPlugIn',
    'thirdPartyPlugins',
    'processingMaterialService',
    function(
        $q,
        $compile,
        $sce,
        $interval,
        ueditorBtnService,
        ueditorService,
        $timeout,
        ueditorPlugIn,
        thirdPartyPlugins,
        processingMaterialService
    ) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                list: '=',
                type: '@',
                versionid: '=',
                newFeatures: '=', // app编辑器新增功能
                hasContent: '=',
                callback: '&',
                editFlag: '=',
                isFusion: '=',
            },
            template:
                // '<div class="editorContainer135"><script id="ueditor" type="text/plain" style="position:relative;width:100%"></script></div>',
                // 调整编辑器页面，增加一键排版，增加分页，增加loading --Add by songjian
                '<div>' +
                '<div class="editorContainer135"  type=\'_weixin\'>' +
                '<script id=\'ueditor\' style=\'width:100%;position:relative\'></script>' +
                '<div class=\'menu-public ueditor_menu\'>' +
                // '<div class=\'menu-bottom-basic pagenum pagenum-first pagenum-cur\' _order=\'1\' click=\'pageAdd($event)\' dblclick=\'pagedelete($event)\'>第 1 页</div>' +
                // '<div class=\'menu-bottom-basic pagemore\' _order=\'0\' click=\'pageAdd($event)\' dblclick=\'pagedelete($event)\'>+</div>' +
                // '<button class=\'key4format\' click=\'keyformat()\'>一键排版</button>' +
                '<div class=\'trs_ueditor_selectionNum\'></div>' +
                '</div>' +
                '</div>' +
                '<div id=\'authorization_box\'>' +
                '<div style=\'margin-top:15px; padding-top:10px; margin-left:25px\'>' +
                '<img src=\'./lib/ueditor2/themes/default/images/loading2.gif\' style=\'vertical-align:middle;\' /><b style=\'padding:0 5px\'>正在排版，请稍候</b><img src=\'./lib/ueditor2/themes/default/images/loading2.gif\' style=\'vertical-align:middle;\' />' +
                '</div>' +
                '</div>' +
                '</div>',
            link: function(scope, element, $attrs) {
                $q.all([thirdPartyPlugins.get135plugins(true), thirdPartyPlugins.getXiumiPlugins(true)]).then(function() {
                    ueditorService.rewriteAutotypesetCache(UE);

                    /* require(['./lib/ueditor2/ueditor.config', './lib/ueditor2/ueditor.all'], function() {*/
                    // var tempArrary = [];
                    var ue;
                    var editorToolBar = ueditorService.getToolBar();
                    // var indexArray = [47, 46, 45, 44, 41, 40, 39, 38, 37, 36, 33, 32, 31, 27, 26, 9, 8, 7, 6, 5, 4, 3];
                    var indexArray = [45, 46, 41, 40, 39, 38, 37, 42, /* 33, 32, 31, 27, 26, 9,*/ 8, 7, 6, 5, 4, 3];
                    editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);

                    /* editorToolBar.toolbars[0].push("insertvideo", "music");*/
                    editorToolBar.pasteplain = false;
                    // var isHttps = window.location.href.indexOf('https://') >= 0 ? 'https' : 'http';

                    /* window.BASEURL = 'https://www.135editor.com';*/
                    // var appkey = '5acb2312-79d8-46c1-a7e8-327279291994';

                    /* 编辑器新增按钮开始*/
                    var ueditorBtn = [];

                    /* 编辑器新增按钮结束*/
                    // 遍历按钮方法，实例化按钮，并返回按钮对象
                    ueditorBtnService.restoreLocalVersion(UE, scope, ue, 0);
                    ueditorBtnService.insertImage(UE, scope, ue, 1);
                    ueditorBtnService.insertInternalLink(UE, scope, ue, 2);
                    ueditorBtnService.insertVideo(UE, scope, ue, 3);
                    ueditorBtnService.aKeyComposing(UE, scope, ue, 4, scope.editFlag.media);
                    ueditorBtnService.multiImgsWaterLink(UE, scope, ue, 0, scope.editFlag.media);

                    editorToolBar.toolbars[0].push('spechars' /* , "button2", "button3"*/, '插入图片');
                    editorToolBar.toolbars[0].splice(7, 0, 'pasteplain');
                    $timeout(function() {
                        ue = window.current_editor = UE.getEditor('ueditor', editorToolBar);
                        var domUtils = baidu.editor.dom.domUtils;
                        ue.ready(function() {
                            // 新增分页
                            angular.element('.ueditor_menu').on('click', function(event) {
                                var event = event || window.event;
                                var target = event.target || event.srcElement;
                                if ($(target).hasClass('menu-bottom-basic')) {
                                    ue.execCommand('pagenum', target);
                                }
                            });
                            // 双击删除分页
                            angular.element('.ueditor_menu').on('dblclick', function(event) {
                                var event = event || window.event;
                                var target = event.target || event.srcElement;
                                if ($(target).hasClass('pagenum')) {
                                    ue.execCommand('del-pagenum', target);
                                }
                            });

                            // scope.list.HTMLCONTENT = ueditorService.replaceHtmlBlank(scope.list.HTMLCONTENT); //将半角空格换为全角空格
                            scope.list.HTMLCONTENT = scope.list.HTMLCONTENT.replace(
                                /<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g,
                                '<hr ispageseparator="true"/>'
                            ); // 替换分页符标签，用于编辑器展示
                            transcodeVideo();
                            ue.getOpt('lang');
                            // ue.setHeight(500);
                            var promise_keyup;
                            var promise_contentChange;
                            ue.addListener('keyup', function() {
                                // 实时双向绑定开始
                                bindContent(promise_keyup);
                            });
                            ue.addListener('contentChange', function() {
                                // 实时双向绑定开始
                                bindContent(promise_contentChange);
                                // 编辑器的必填提示
                                $timeout(function() {
                                    var content = ue.getContent();
                                    if (content !== '') {
                                        scope.hasContent = true;
                                    } else {
                                        scope.hasContent = false;
                                    }
                                });
                            });
                            // ueditorPlugIn.weixinImgFixed(ue); // 微信图片压缩及下载服务
                            // 计算显示字数，并显示出来
                            domUtils.on(ue.body, 'mouseup', function(event) {
                                selectionNumPop(event);
                            });
                            domUtils.on(ue.body, 'keydown', function(event) {
                                selectionNumPop(event);
                            });
                            // 显示选中区域的字数
                            ue.addListener('selectionchange', function() {
                                // 查看痕迹后或进入源码模式下禁用编辑器按钮
                                if (this.body.contentEditable == 'false' || this.sourceMode === true) {
                                    for (var k in ueditorBtn) {
                                        if (ueditorBtn[k] !== '') {
                                            ueditorBtn[k].addState('disabled');
                                        }
                                    }
                                } else {
                                    for (var j in ueditorBtn) {
                                        if (ueditorBtn[j] !== '') {
                                            ueditorBtn[j].removeState('disabled');
                                        }
                                    }
                                }
                                var selectionStr = this.selection.getText();
                                if (selectionStr.length === 0) {
                                    hideSelectionNum();
                                }
                            });
                            // 编辑器失焦是字数显示消失
                            ue.addListener('blur', function() {
                                hideSelectionNum();
                            });

                            /**
                             * [showSelectionNum description] 显示选中字数统计
                             * @param   {[type]}  position  [position description]
                             * @return  {[type]}            [return description] null
                             */
                            function showSelectionNum(position) {
                                var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                selectionNumDiv.css('left', position.left + 'px');
                                selectionNumDiv.css('top', position.top + 'px');
                                selectionNumDiv.fadeIn('fast');
                            }

                            /**
                             * [hideSelectionNum methodname]显示选中字数统计
                             * @return {[type]} [description] null
                             */
                            function hideSelectionNum() {
                                $(document)
                                    .find('.trs_ueditor_selectionNum')
                                    .fadeOut('fast');
                            }

                            /**
                             * [selectionNumPop description] 显示选中字数统计
                             * @param   {[type]}  event  [event description]
                             * @return  {[type]}         [return description]
                             */
                            function selectionNumPop(event) {
                                var selectionStr = ue.selection.getText();
                                if (selectionStr.length !== 0) {
                                    var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                    var position = {};
                                    selectionNumDiv.html(
                                        '已选中' +
                                            selectionStr
                                                .replace(/&nbsp;/g, '')
                                                .replace(/\u00a0/g, '')
                                                .replace(/\u3000/g, '')
                                                .replace(/\n/, '').length +
                                            '个字'
                                    );
                                    showSelectionNum(position);
                                } else {
                                    hideSelectionNum();
                                }
                            }
                            ueditorService.compareLocalAndServe(scope, scope.type).then(function() {
                                scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                            });
                            // MLFWEB-5014 修复全屏的bug
                            ue.addListener('fullscreenchanged', function(type, bfullscreen) {
                                scope.infullscreen = bfullscreen;
                                var $iframeHolder = $('.edui-editor-iframeholder');
                                $iframeHolder.css('width', '100%');
                                var doc = $iframeHolder.find('iframe')[0].contentWindow.document;
                                doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
                                if (!bfullscreen) {
                                    doc.body.style.height = 'initial';
                                }
                                $timeout(function() {
                                    ue.selection.getRange().collapsed = true;
                                    ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
                                    ue.execCommand('inserthtml', '<trsfullscreen></trsfullscreen>');
                                    var doms = doc.getElementsByTagName('trsfullscreen');

                                    for (var index = 0; index < doms.length; index++) {
                                        doms[index].parentNode.removeChild(doms[index]);
                                    }

                                    ue.fireEvent('contentChange');
                                });
                            });
                        });
                        scope.$on('$destroy', function() {
                            $interval.cancel(scope.promise); // 销毁定时事件
                        });

                        /**
                         * [bindContent description] 绑定数据和编辑器内容
                         * @param   {[type]}  promise  [promise description]
                         * @return  {[type]}           [return description]
                         */
                        function bindContent(promise) {
                            if (promise) {
                                $timeout.cancel(promise);
                                promise = null;
                            }
                            promise = $timeout(function() {
                                scope.list.DOCWORDSCOUNT = ueditorService.getDOCWORDSCOUNT(ue);
                            }, 500);
                            return promise;
                        }

                        /**
                         * [transcodeVideo description] 查询转码中的视频，若转码完成则替换封面图
                         *
                         * @return  {[type]}  [return description]
                         */
                        function transcodeVideo() {
                            processingMaterialService.transcodeVideo(scope.list).then(function (html) {
                                html ? scope.list.HTMLCONTENT = html : '';
                                ue.setContent(scope.list.HTMLCONTENT);
                                getContentNum();
                            });
                        }

                        /**
                         * [getContentNum description] 计算字数
                         *
                         * @return  {[type]}  [return description]
                         */
                        function getContentNum() {
                            // 纯文本正文及字数
                            var preContent = ueditorService.getTextContent(ue.getContentTxt()).replace(/\n/g, '');
                            scope.list.DOCWORDSCOUNT = preContent
                                .replace(/\n/g, '')
                                .replace(/\u0020/g, '')
                                .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                            // 纯文本正文及字数
                            var preResult = $sce.getTrustedHtml("<div class='display_none ueditorWordCount'>已输入<span class='color-red'>{{list.DOCWORDSCOUNT}}</span>个字</div>");
                            var result = $compile(preResult)(scope);
                            // element.find('.edui-editor').append(result);
                            element.find('.edui-editor-toolbarboxinner').append(result);
                            var destroyWatch = scope.$watch('list.DOCWORDSCOUNT', function(newValue) {
                                if (newValue) {
                                    $timeout(function() {
                                        result.removeClass('display_none');
                                        destroyWatch();
                                    });
                                }
                            });
                        }

                        /**
                         * [localcache methodname]本地保存
                         * @return {[type]} [description] null
                         */
                        function localcache() {
                            ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
                        }
                        // 监控metadataid变化，并将正文更新进入本地版本
                        ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);
                        // 重写全屏方法
                        ueditorService.rewriteFullScreen(UE, 60);
                        // 编辑器中图片工具条
                        ueditorPlugIn.pictureToolbarForWeixin(ue, scope, domUtils, function(fileName) {
                            if (scope.callback()) {
                                scope.callback()(fileName);
                            }
                        });
                        // 视频的获取工具条
                        // ueditorPlugIn.videoToolbar_(ue, scope);
                        /** 点击触发外部播放器*/
                        ueditorPlugIn.videoPlayer(ue, scope);
                        // ueditorPlugIn.audioToolbar(ue, scope);//音频的获取工具条
                        scope.$on('$destroy', function() {
                            ueditorService.destroyCommonUe(ue);
                        });
                        ueditorPlugIn.spaceIndent(ue, domUtils);
                        ueditorPlugIn.outlinkPicDownload(ue, domUtils, scope.editFlag.media);
                        ueditorPlugIn.clickSource(ue);
                        ueditorPlugIn.disableImagenote(ue, scope.isFusion);
                        ueditorPlugIn.replaceWeixinVideo(ue, domUtils);
                        ueditorPlugIn.fixContentInImageWrap(ue);
                        // ueditorPlugIn.addContentBeforeHtml(ue);
                        ueditorPlugIn.fixPasteFromMicoWord(ue);
                    });
                });
            },
        };
    },
]);
